import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Radio, Select } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import ZaroPayQR from "./ZaroPayQR.jsx"
import Balance from '../../../../../assets/Balance.jsx';
import { ZaropayDepositAmountApi } from '../../../../../api/request/wallet/deposit.js';

const ZaroPay = ({ amount, paymentMethod, loginTerminalId, resetAll, validateAmount, accounts = [] }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [isDepositLoading, setIsDepositLoading] = useState(false);
    const [depositdata, setDepositdata] = useState(null);
    const [step, setStep] = useState(1);
    const [selectedAccount, setSelectedAccount] = useState(loginTerminalId || null);

    const currencyOptions = [
        { label: "USDT_TRC20", value: 1 },
        { label: "USDT_ERC20", value: 2 },
        { label: "USDT_BEP20", value: 3 },
    ];

    const handleSubmit = async (values) => {
        setIsDepositLoading(true);
            try {
            if (validateAmount) {
                toast.error(validateAmount);
                return;
            }
            if (!amount) {
                toast.error('Please enter deposit amount');
                return;
            }
            // Prefer loginTerminalId from the form values (if user selected an account)
            const isWallet = loginTerminalId === 'wallet';
 
            
            const deposiParams = {
                userId: userDetails?.id,
                paymentGatwayId: paymentMethod?.id,
                amount: Number(amount),
                loginTerminalId: isWallet ? 0 : loginTerminalId,
                currency: values?.currency,
            };
            const { data } = await ZaropayDepositAmountApi(deposiParams);
            if (data?.success) {
                form.resetFields();
                setDepositdata(data?.data);
                setStep(2);
            }
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || 'Deposit failed.');
        } finally {
            setIsDepositLoading(false);
        }
    };

    return (
        <div>
            {step === 1 && (
                <Form form={form} layout='vertical' className='space-y-5' onFinish={handleSubmit}>
                    <Form.Item
                        name="currency"
                        label={<span className="text-lg text-gray-500 font-medium">Currency</span>}
                        rules={[{ required: true, message: "Please select currency" }]}
                    >
                        <Select className="!w-full sm:!w-1/2" placeholder="Select type" options={currencyOptions} />
                    </Form.Item>

                    {/* <Form.Item
                        name="loginTerminalId"
                        label={<span className="text-lg text-gray-500 font-medium">Select Account</span>}
                        rules={[{ required: true, message: 'Please select an account.' }]}
                    >
                        <Radio.Group className="w-full grid grid-cols-1 md:grid-cols-2  gap-3">
                            <Radio
                                value={"wallet"}
                                className={`flex items-center gap-1 border-2 rounded-lg p-3 m-0 ${selectedAccount === "wallet" ? 'border-primary' : 'border-light'}`}
                                onChange={(e) => setSelectedAccount(e?.target?.value)}
                            >
                                <div className='flex items-center justify-center gap-3'>
                                    <Balance color="#00727D" className="size-8" />
                                    <p className='text-lg'>Wallet</p>
                                </div>
                            </Radio>

                            {accounts?.map((item, index) => (
                                <Radio
                                    key={index}
                                    value={item?.terminalID}
                                    className={` ${item?.terminalID == 0 ? 'hidden' : ''} flex items-center gap-2 border-2 rounded-lg ps-1 py-2 m-0 ${selectedAccount === item?.terminalID ? 'border-primary' : 'border-light'}`}
                                    onChange={(e) => setSelectedAccount(e?.target?.value)}
                                >
                                    <div className='flex items-center justify-center gap-5'>
                                        <img
                                            src="/assets/images/vertex_logo.png"
                                            alt="Icon"
                                            className="h-[35px] w-[35px] object-contain"
                                        />
                                        <div>
                                            <p className='text-lg'>{item?.terminalID}</p>
                                            <p>${item?.balance || 0}</p>
                                        </div>
                                    </div>
                                </Radio>
                            ))}
                        </Radio.Group>
                    </Form.Item> */}

                    <Form.Item
                        name='conditions'
                        valuePropName="checked"
                        rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
                    >
                        <Checkbox className='mt-4'>
                            Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
                        </Checkbox>
                    </Form.Item>

                    <LoadableButton
                        className='block bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                        type="submit"
                        lable='Next'
                        isLoading={isDepositLoading}
                    />
                </Form>
            )}

            {step === 2 && (
                <ZaroPayQR depositdata={depositdata} resetAll={resetAll} />
            )}
        </div>
    )
}

export default ZaroPay
